<template>
    <div class="article main-top-border main-bg">
        <div class="main-wrap mt20" style="background-color:#f7f6f9">
            <div class="fl article-left">
                <div class="search-box">
                    <input type="text" placeholder="搜索" v-model="searchKey" class="inp-txt" @keyup.enter="getNewsPageList()" />
                    <i class="ico-search el-icon-search" @click="getNewsPageList()"></i>
                </div>
                <el-tabs v-model="activeName" @tab-click="toggleTab" class="article-tab">
                    <el-tab-pane
                            v-for="item in oneTypeList"
                            :key="item.id"
                            :label="item.typeName"
                            :name="item.typeName"
                            :id="item.id"
                    >
                        <ul class="article-list">
                            <li v-for="(listItem,listIndex) in articleList" :key="listIndex" @click="$router.push({'path':`/article/detail/${listItem.id}`})">
                                <div class="fl info">
                                    <h3 class="title">{{listItem.title}}</h3>
                                    <p class="desc">
                                        <span class="desc-txt" v-text="listItem.desc?$common.interceptStr(listItem.desc,80):''"></span>
                                    </p>
                                    <a class="btn-read">阅读全文</a>
                                    <p class="time"><i class="el-icon-time"></i>{{listItem.createTime}}</p>
                                </div>
                                <div class="fr">
                                    <el-image class="img" :src="$common.imgPath(listItem.img)" :alt="listItem.img" fit="cover"></el-image>
                                </div>
                            </li>
                        </ul>
                        <!--{{item.content}}-->
                    </el-tab-pane>
                </el-tabs>
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="current"
                        layout=" prev, pager, next,total, jumper"
                        style="text-align: center;padding:20px;"
                        :hide-on-single-page="isOnePage"
                        :total="totalPage">
                </el-pagination>

            </div>
            <div class="fr">
                <!--<div class="refresh-auth">
                    <div class="tit"><div class="auth">推荐作者</div><div class="huan"><i class="el-icon-refresh"></i>换一批</div></div>
                    <ul class="tui-list">
                        <li>
                            <div class="tx"></div>
                            <div class="auth-info">
                                <p class="auth-name">王小麦</p>
                                <p>20391关注 <span class="dian"></span>写了27篇文章</p>
                            </div>
                            <a class="follow">+关注</a>
                        </li>
                        <li>
                            <div class="tx"></div>
                            <div class="auth-info">
                                <p class="auth-name">王小麦</p>
                                <p>20391关注 <span class="dian"></span>写了27篇文章</p>
                            </div>
                            <a class="follow">+关注</a>
                        </li>
                    </ul>
                    <button type="button" class="btn-all">查看全部 ></button>
                </div>-->
                <div class="down-app">
                    <img src="../../assets/images/qrCode.png" alt="" class="app-qr">
                    <div class="down-txt">
                        <a class="go-down">下载名人名兰手机app</a>
                        <p class="app-desc">随时随地发现和创作文章</p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import {getIndexOneType} from '../../api/goods'
    import {getNewsPage} from '../../api/news'
    export default {
        data(){
            return {
                searchKey:'',//搜索关键字
                activeName:'全部',//活动tab
                current:1,
                size:10,
                totalPage:0,
                isOnePage:false,//是否只有一页
                currentIndex:'0',
                currentId:'',
                articleList:[],
                oneTypeList:[
                    {
                        id:'',
                        typeName:'全部',

                    }
                ],//一级分类列表

            }
        },
        created(){
            this.getIndexOneType();
        },
        methods:{
            toggleTab(tab, event) {
                this.current=1;
                this.currentId=tab.$attrs.id;
                this.getNewsPageList();
            },
            getIndexOneType(){
                getIndexOneType({
                    type:2
                }).then(res=>{
                    if(res.data){
                        this.oneTypeList.push(...res.data);
                        this.getNewsPageList();//取第一个
                    }
                })
            },
            handleCurrentChange(current){
                this.current=current;
                this.getNewsPageList();
            },
            getNewsPageList(){
                let params={
                    current:this.current,
                    size:this.size
                };
                if(this.searchKey!==''){
                    params['key']=this.searchKey;
                }
                if(this.currentId!==''){
                    params['oneTypeId']=this.currentId;
                }
                getNewsPage(params).then(res=>{
                    const {total,records} = res.data;
                    this.totalPage=total;
                    this.articleList=records;
                    this.isOnePage=this.totalPage<=this.size?true:false;
                })
            },
            getActiveList(id,index){
                this.currentIndex=index;
                this.currentId=id;
                this.getNewsPageList();
            }
        },
        filters:{
            interceptStr(str){
                let newStr='';
                if(str.length>80){
                    newStr=str.substr(0,80)+'...';
                }else {
                    newStr=str;
                }
                return newStr;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/css/common';
    .main-wrap{
        background-color:#ffffff;
        overflow: hidden;
    }
    .article-left{
        padding: 15px 30px 30px;
        width:830px;
        position: relative;
        background-color:#ffffff;
        .search-box{
            position: absolute;
            top:15px;
            right:30px;
            z-index: 100;
            display: table;
            width:156px;
            height:44px;
            padding:0 14px 0 30px;
            background-color:#F7F7F7;
            border:1px solid #E6E6E6;
            -webkit-border-radius: 22px;
            -moz-border-radius: 22px;
            border-radius: 22px;
            .inp-txt{
                display: table-cell;
                width:130px;
                height:100%;
                color:#666666;
                font-size:16px;
                background: transparent;
            }
            .ico-search{display: table-cell;font-size:20px;color:#999999;
                vertical-align: middle;}
        }
        .article-list{
            li{
                overflow: hidden;
                padding:24px 0;
                cursor: pointer;
                &+li{
                    border-top:1px solid #EEEEEE;
                }
                .info{
                    width:530px;
                    .title{
                        font-size:26px;
                        color:#222222;
                        line-height:42px;
                    }
                    .desc{
                        /*height:75px;*/
                        font-size:16px;
                        color:#565656;

                    }
                    .btn-read{font-weight:600;
                        line-height: 40px;}
                    .time{
                        color:#999999;
                        font-size:16px;
                        line-height:42px;
                    }
                }
                .img{
                    width:210.5px;
                    height:150px;
                    background-color:$main-color;
                    -webkit-border-radius: 6px;
                    -moz-border-radius: 6px;
                    border-radius: 6px;
                    img{width:100%;
                        height:100%;object-fit: cover;}
                }

            }
        }
    }
    .refresh-auth{
        padding:20px;
        width:314px;
        background-color:#ffffff;
        .tit{
            display: table;
            color:#333333;

            width:100%;
            padding-bottom:4px;
            .auth{
                display: table-cell;
                text-align: left;
                font-weight:600;
                font-size:18px;
            }
            .huan{
                display: table-cell;
                text-align: right;
                font-size:14px;
            }

        }
        .tui-list{
            li{
                display: table;
                padding-top:20px;
                &>*{
                    display: table-cell;
                }
                .tx{
                    width:60px;
                    height:60px;
                    background-color:$main-color;
                    -webkit-border-radius: 50%;
                    -moz-border-radius: 50%;
                    border-radius: 50%;
                }
                .auth-info{
                    padding:0 20px 0 6px;
                    font-size:14px;
                    white-space:nowrap;
                    .auth-name{
                        color:#333333;
                        font-size:18px;
                        padding-bottom:5px;
                    }
                    .dian{
                        display: inline-block;
                        width:3px;
                        height:3px;
                        vertical-align: middle;
                        margin:0 5px;
                        background-color:#999999;
                        -webkit-border-radius: 50%;
                        -moz-border-radius: 50%;
                        border-radius: 50%;
                    }
                }
                .follow{
                    font-size: 16px;
                    color:$main-color;
                }
            }
        }
        .btn-all{
            width:314px;
            height:39px;
            line-height:39px;
            border:1px solid #CBCBCB;
            background-color: #F7F7F7;
            font-size:18px;
            color:#333333;
            -webkit-border-radius: 3px;
            -moz-border-radius: 3px;
            border-radius: 3px;
            margin:30px 0 14px;
        }
    }
    .down-app{
        padding:30px 30px 34px 20px;
        background-color:#ffffff;
        /*margin-top:10px;*/
        display: table;
        &>*{
            display: table-cell;
        }
        .app-qr{
            width:93px;
            height:93px;
            background: $main-color;
        }
        .down-txt{
            padding-left:19px;
            vertical-align: middle;
            .go-down{
                font-size:18px;
                color: #333333;
            }
            .app-desc{font-size:16px;
                color: #999999;margin-top:22px;}
        }
    }


</style>
<style lang="scss">
    @import '../../assets/css/common';
    .article{
        .article-tab .el-tabs__header:after{
            content: '';
            position: absolute;
            bottom:0;
            left:0;
            width: 100%;
            border-bottom:1px solid #E2E2E2;
        }
        .article-tab .el-tabs__nav-wrap::after{
            width:0;
        }
        .article-tab .el-tabs__nav-wrap{width:500px;}
        .article-tab .el-tabs__item.is-active{color:$main-color;}
        .article-tab .el-tabs__item{color:#333333;font-size:18px;height:50px;padding:0 13px;width:65px;text-align: center}
        .article-tab .el-tabs__active-bar{background-color:$main-color;}
        .article-tab .el-tabs__item:hover{color:$main-color;}
    }
</style>